import BlRatingMv from './BlRatingMv.vue'
BlRatingMv.install = function(Vue) {
  Vue.component(BlRatingMv.name, BlRatingMv)
}
export default BlRatingMv
